const INITIAL_STATE = {
  user: {
    first_name: "",
    last_name: "",
    username: "",
    token: "",
    is_login: false,
  },
};

const Store = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LOGIN_USER":
      return {
        ...state,
        user: {
          ...action.user,
          is_login: true,
        },
      };

    case "LOGOUT_USER":
      return INITIAL_STATE;

    case "EXCEL_SUMMARY":
      return {
        ...state,
        excel_summary: action.data,
      };

    default:
      return state;
  }
};
export default Store;
